// src/components/quiz/StreakCalendar.tsx
import React from 'react';
import dayjs from 'dayjs';
import { useStreak } from '../../hooks/useStreak'; // パスは適宜調整

const StreakCalendar: React.FC<{ userId: string }> = ({ userId }) => {
    const { streakDays, completionDateList } = useStreak(userId);

    const today = dayjs();
    const todayFormatted = today.format('YYYY-MM-DD');
    const yesterdayFormatted = today.subtract(1, 'day').format('YYYY-MM-DD');
    const startOfMonth = today.startOf('month');
    const daysInMonth = today.daysInMonth();

    const days = Array.from({ length: daysInMonth }, (_, i) => startOfMonth.add(i, 'day'));
    const completionSet = new Set(completionDateList);

    const getColorClass = (completed: boolean, isToday: boolean) => {
        const base = completed
            ? 'bg-gradient-to-br from-green-400 to-emerald-500 text-white'
            : 'bg-white border border-gray-300 text-gray-600'; // テキストの色を変更
        return isToday ? `${base} ring-2 ring-blue-500 ring-offset-1` : base; // リングを調整
    };

    const weekDays = ['日', '月', '火', '水', '木', '金', '土'];

    const firstDayOfWeek = startOfMonth.day();
    const blankDays = Array.from({ length: firstDayOfWeek }, (_, i) => <div key={`blank-${i}`} className="w-9 h-9" />); // サイズを調整

    const hasRecent = completionSet.has(todayFormatted) || completionSet.has(yesterdayFormatted);
    const displayStreak = hasRecent ? streakDays : 0;

    return (
        <div className="flex flex-col items-center space-y-4 w-full max-w-xs sm:max-w-sm p-5 bg-white rounded-xl shadow-lg border border-gray-100"> {/* コンテナを強化 */}
            <div className="text-xl sm:text-2xl font-extrabold text-gray-800 mb-2"> {/* ストリーク表示を強化 */}
                連続記録：<span className="text-green-600">{displayStreak}</span>日
            </div>
            <div className="grid grid-cols-7 gap-2 w-full"> {/* 必要に応じてギャップをわずかに調整 */}
                {weekDays.map((day) => (
                    <div key={day} className="text-center text-xs font-medium text-gray-500 p-1 rounded-md"> {/* パディングと角丸を追加 */}
                        {day}
                    </div>
                ))}
                {blankDays}
                {days.map((date) => {
                    const formatted = date.format('YYYY-MM-DD');
                    const completed = completionSet.has(formatted);
                    const isToday = formatted === todayFormatted;
                    return (
                        <div
                            key={formatted}
                            className={`w-9 h-9 text-sm flex items-center justify-center rounded-lg shadow-sm transition-all duration-200 ease-in-out ${getColorClass(completed, isToday)}`} // サイズ、丸み、トランジションを調整
                            title={formatted + (completed ? ' ✅' : '')}
                        >
                            {date.format('D')}
                        </div>
                    );
                })}
            </div>
            <div className="text-sm text-gray-500 mt-2">{today.format('YYYY年M月')}の記録</div> {/* margin-topを調整 */}
        </div>
    );
};

export default StreakCalendar;